import { MonitoringPageType } from '../../monitoring/constants';

export class SetHandlingUnitItemParams {
  public static readonly type = '[HandlingUnitItem] Set Handling Unit Params';
  constructor(
    public payload: {
      handlingUnitNumber: string;
      deliveryNoteNumber: string;
      sapId: string;
      parentRoute: boolean;
      monitoringPageType: MonitoringPageType;
    },
  ) {}
}

export class HandlingUnitItemInitialState {
  public static readonly type = '[HandlingUnitItem] Set initial state';
}
